import React, { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import CloseIcon from "../../assets/images/close.png";


import { TfiTrash } from "react-icons/tfi";
import { Disable } from 'react-disable';
import { TfiClose, TfiTag } from "react-icons/tfi";
import { TfiCalendar, TfiUser } from "react-icons/tfi";


import { connect } from "react-redux";
import { compose } from "redux";


import { getFinding, addAttachmentAction, editAction, getActionDetails, addActionComment, addFindingComment } from "../../store/actions/riskActions";
import { getUsers } from "../../store/actions/adminActions";
import Select, { components } from "react-select";

import moment from 'moment';
import debounce from "lodash/debounce";




const FindingOverlay = (props) => {

    const {finding_comments, comments, addFindingCommentFN, finding, finding_id, getFindingFN, closeFinding, onSave } = props;
    const { t } = useTranslation();




    const [form, setForm] = useState({
        id: "",                 // derived from finding_id + year
        title: "",
        priority: "Medium",     // not in DB; pick a sensible default
        status: "Open",         // maps from DB (Open | Closed | Problem)
        finding_date: "",       // yyyy-mm-dd
        due_date: "",           // not in DB yet
        assigned_to: "",        // not in DB yet
        category: "",           // not in DB yet
        description: "",
        root_cause: "",
        impact: "",
        recommendation: "",
        control_title: "",
        approval_status: "",

    });

    const badgeColor = {
        High: "bg-amber-100 text-amber-800 border-amber-300",
        Medium: "bg-yellow-100 text-yellow-800 border-yellow-300",
        Low: "bg-green-100 text-green-800 border-green-300",
        Urgent: "bg-red-100 text-red-800 border-red-300",
    }[form.priority] || "bg-gray-100 text-gray-700 border-gray-300";

    const statusColor = {
        "In Progress": "bg-purple-100 text-purple-800 border-purple-300",
        Open: "bg-blue-100 text-blue-800 border-blue-300",
        Closed: "bg-green-100 text-green-800 border-green-300",
        Problem: "bg-rose-100 text-rose-800 border-rose-300",
    }[form.status] || "bg-gray-100 text-gray-700 border-gray-300";


    const [commentState, setCommentState] = useState('');

    useEffect(() => {
        if (finding_id)
            getFindingFN(finding_id);

    }, [finding_id]);


    useEffect(() => {
        if (!finding) return;

        const year = finding.finding_date
            ? new Date(finding.finding_date).getFullYear()
            : new Date().getFullYear();

        setForm({
            id: `FIN-${year}-${String(finding.id).padStart(3, "0")}`,
            title: finding.title ?? "",
            priority: "Medium", // still filler until you add this to DB
            status: finding.status || "Open", // 'Open' | 'Closed' | 'Problem'
            finding_date: toDateInput(finding.finding_date), // -> 'YYYY-MM-DD'
            due_date: "",           // filler
            assigned_to: finding.owner_name || "",        // filler
            category: "",           // filler
            description: finding.description ?? "",
            root_cause: finding.root_cause ?? "",
            impact: finding.impact ?? "",
            recommendation: finding.recommendation ?? "",
            control_title: finding.control_title ?? "",
            approval_status: finding.approval_status ?? "",
        });
    }, [finding]);


    const toDateInput = (iso) => {
        if (!iso) return "";
        const d = new Date(iso);
        const pad = (n) => String(n).padStart(2, "0");
        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    };

    const handleAddComment = async (comment, finding) => {
        setCommentState("");
        await addFindingCommentFN(comment, finding);
        getFindingFN(finding_id);


    };

    return (
    <div className="fixed inset-0 z-[999] flex items-start justify-center bg-black/30">
        <div className="relative mt-6 w-[720px] max-w-[95vw] rounded-xl bg-white shadow-xl border border-gray-200 max-h-[90vh] overflow-y-auto">
            {/* Header */}
            <div className="flex items-start justify-between gap-4 p-5">
                <div className="flex-1">
                    <input
                        className="w-full text-xl font-semibold text-gray-900 bg-transparent outline-none"
                        value={form.title}
                        onChange={(e) => setForm({ ...form, title: e.target.value })}
                    />
                    <div className="mt-1 text-xs text-gray-500">{t("findingsPage.detailModal.findingIdLabel")}: {form.id}</div>
                </div>

                <button
                    onClick={(e) => closeFinding(form, finding_id, e)}
                    className="ml-1 rounded-full p-1.5 hover:bg-gray-100 text-gray-500"
                    aria-label="Close"
                >
                    <TfiClose className="w-4 h-4" />
                </button>
            </div>

            {/* Meta grid */}
            <div className="grid grid-cols-2 gap-4 px-5">
                {/* Row 1: Finding Date */}
                <div className="flex items-center gap-2">
                    <TfiCalendar className="w-4 h-4 text-gray-600 self-center translate-y-[1px]" />
                    <div className="flex-1">
                        <div className="text-xs text-gray-500">{t("findingsPage.detailModal.findingDate")}</div>
                        <input
                            type="date"
                            className="mt-0.5 text-sm text-gray-900 bg-transparent outline-none cursor-pointer w-[130px] appearance-none"
                            value={form.finding_date}
                            onChange={(e) => setForm({ ...form, finding_date: e.target.value })}
                        />
                    </div>
                </div>

                {/* Row 1: Owner */}
                <div className="flex items-center gap-2">
                    <TfiUser className="w-4 h-4 text-gray-600 self-center translate-y-[1px]" />
                    <div className="flex-1">
                        <div className="text-xs text-gray-500">{t("findingsPage.detailModal.owner")}</div>
                        <input
                            readOnly
                            className="mt-0.5 w-full text-sm text-gray-900 bg-transparent outline-none"
                            value={form.assigned_to || form.owner_name || ""}
                        />
                    </div>
                </div>

                {/* Row 2: Status */}
                <div className="flex items-center gap-3 pl-[26px]">
                    <label className="text-xs text-gray-500 min-w-[48px]">{t("findingsPage.detailModal.status")}</label>
                    <select
                        className="max-w-[130px] text-xs h-8 rounded-md border border-gray-200 bg-white px-2 pr-5 text-gray-900 shadow-sm hover:border-gray-300 focus:outline-none focus:ring-0 focus:border-gray-400"
                        value={form.status || "Open"}
                        onChange={(e) => setForm({ ...form, status: e.target.value })}
                    >
                        <option value="Open">{t("findingsPage.detailModal.statusOpen")}</option>
                        <option value="Problem">{t("findingsPage.detailModal.statusProblem")}</option>
                        <option value="Closed">{t("findingsPage.detailModal.statusClosed")}</option>
                    </select>
                </div>

                {/* Row 2: Control */}
                <div className="flex items-center gap-2">
                    <TfiTag className="w-4 h-4 text-gray-600 self-center translate-y-[1px]" />
                    <div className="flex-1">
                        <div className="text-xs text-gray-500">{t("findingsPage.detailModal.control")}</div>
                        <input
                            readOnly
                            className="mt-0.5 w-full text-sm text-gray-900 bg-transparent outline-none"
                            value={form.control_title || ""}
                        />
                    </div>
                </div>

                {/* Row 3: Approval Status */}
                <div className="flex items-center gap-3 pl-[26px]">
                    <label className="text-xs text-gray-500 min-w-[48px]">{t("findingsPage.detailModal.approval")}</label>
                    <select
                        className="max-w-[130px] text-xs h-8 rounded-md border border-gray-200 bg-white px-2 pr-5 text-gray-900 shadow-sm hover:border-gray-300 focus:outline-none focus:ring-0 focus:border-gray-400"
                        value={form.approval_status || "Pending"}
                        onChange={(e) => setForm({ ...form, approval_status: e.target.value })}
                    >
                        <option value="Pending">{t("findingsPage.detailModal.approvalPending")}</option>
                        <option value="Approved">{t("findingsPage.detailModal.approvalApproved")}</option>
                        <option value="Rejected">{t("findingsPage.detailModal.approvalRejected")}</option>
                    </select>
                </div>
            </div>

            <div className="mt-4 border-t border-gray-200" />

            {/* Description */}
            <section className="px-5 py-4">
                <h4 className="mb-2 text-sm font-semibold text-gray-800 flex items-center gap-2">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-4 h-4 text-gray-700"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.6"
                        stroke="currentColor"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M12 9v6m-3-3h6m-9 7h12a2 2 0 002-2V7a2 2 0 00-2-2H6a2 2 0 00-2 2v10a2 2 0 002 2z"
                        />
                    </svg>
                    {t("findingsPage.detailModal.description")}
                </h4>
                <textarea
                    rows={3}
                    className="w-full resize-y rounded-lg border border-gray-200 bg-white p-3 text-sm text-gray-900"
                    value={form.description}
                    onChange={(e) => setForm({ ...form, description: e.target.value })}
                />
            </section>

            <div className="border-t border-gray-200" />

            {/* Root Cause */}
            <section className="px-5 py-4">
                <h4 className="mb-2 text-sm font-semibold text-gray-800">{t("findingsPage.detailModal.rootCause")}</h4>
                <textarea
                    rows={3}
                    className="w-full resize-y rounded-lg border border-gray-200 bg-white p-3 text-sm text-gray-900"
                    value={form.root_cause}
                    onChange={(e) => setForm({ ...form, root_cause: e.target.value })}
                />
            </section>

            <div className="border-t border-gray-200" />

            {/* Impact */}
            <section className="px-5 py-4">
                <h4 className="mb-2 text-sm font-semibold text-gray-800">{t("findingsPage.detailModal.impact")}</h4>
                <textarea
                    rows={3}
                    className="w-full resize-y rounded-lg border border-gray-200 bg-white p-3 text-sm text-gray-900"
                    value={form.impact}
                    onChange={(e) => setForm({ ...form, impact: e.target.value })}
                />
            </section>

            <div className="border-t border-gray-200" />

            {/* Recommendation */}
            <section className="px-5 py-4">
                <h4 className="mb-2 text-sm font-semibold text-gray-800">{t("findingsPage.detailModal.recommendation")}</h4>
                <div className="rounded-xl border border-gray-200 bg-gray-50">
                    <textarea
                        rows={3}
                        className="w-full resize-y rounded-xl bg-gray-50 p-3 text-sm text-gray-900 outline-none"
                        value={form.recommendation}
                        onChange={(e) => setForm({ ...form, recommendation: e.target.value })}
                    />
                </div>
            </section>

            <div className="border-t border-gray-200" />

            {/* Comments */}
            <section className="px-5 py-4">
                <h4 className="font-semibold mb-3 text-[#3b3b3b]">{t("findingsPage.detailModal.comments")}</h4>

                {!!comments?.length && (
                    <div className="mb-4 space-y-3">
                        {comments.map((comment) => (
                            <div
                                key={comment.CommentID}
                                className="rounded-xl border border-gray-200 bg-gray-50 px-3 py-2"
                            >
                                <div className="flex items-center justify-between gap-3">
                                    <div className="text-sm font-medium text-gray-800">
                                        {[comment.FirstName, comment.LastName].filter(Boolean).join(" ") || t("findingsPage.detailModal.unknownUser")}
                                    </div>
                                    <div className="text-xs text-gray-500">
                                        {comment.CommentDate
                                            ? new Date(comment.CommentDate).toLocaleString()
                                            : ""}
                                    </div>
                                </div>
                                <div className="mt-1 text-sm text-gray-700 whitespace-pre-wrap">
                                    {comment.CommentText}
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                <div className="mb-6">
                    <textarea
                        placeholder={t("findingsPage.detailModal.commentsPlaceholder")}
                        className="w-full p-3 text-sm rounded bg-[#EEF0ED] text-black"
                        style={{
                            border: 'none',
                            backgroundColor: '#EEF0ED',
                            padding: '8px',
                            outline: 'none',
                            transition: 'box-shadow 0.1s',
                            boxShadow: 'inset 0 0 0 0 #3b3b3b',
                        }}
                        onFocus={(e) => (e.target.style.boxShadow = 'inset 0 -2px 0 0 #3b3b3b')}
                        onBlur={(e) => (e.target.style.boxShadow = 'inset 0 0 0 0 #3b3b3b')}
                        value={commentState}
                        onChange={(e) => setCommentState(e.target.value)}
                    />

                    <div className="flex justify-end mt-4">
                        <button
                            onClick={() => {
                                if (commentState?.trim()) {
                                    handleAddComment(commentState, finding_id)
                                }
                            }}
                            disabled={!commentState?.trim()}
                            className={`
                                inline-flex items-center justify-center
                                px-5 py-2.5
                                text-sm font-medium
                                rounded-xl
                                transition-all duration-200 ease-out
                                shadow-sm
                                ${commentState?.trim()
                                    ? "bg-gradient-to-r from-gray-900 to-gray-700 text-white hover:shadow-md hover:-translate-y-[1px] active:translate-y-0"
                                    : "bg-gray-200 text-gray-400 cursor-not-allowed"
                                }
                            `}
                        >
                            {t("findingsPage.detailModal.addComment")}
                        </button>
                    </div>
                </div>
            </section>
        </div>
    </div>
);

};


const mapStateToProps = (state) => {
    //console.log("Finding ", state.risk.control_details)
    return {

        finding: state.risk.control_details?.finding_details,
        comments: state.risk.control_details?.finding_comments,

    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        addAttachmentActionFN: (risk_id, action_id, file) => dispatch(addAttachmentAction(risk_id, action_id, file)),
        editActionFN: (risk_id, action_id, action) => dispatch(editAction(risk_id, action_id, action)),
        getActionDetailsFN: (risk_id, action_id) => dispatch(getActionDetails(risk_id, action_id)),
        addActionCommentFN: (comment, action_id) => dispatch(addActionComment(comment, action_id)),
        getFindingFN: (finding_id) => dispatch(getFinding(finding_id)),
        getUsersFN: () => dispatch(getUsers()),
        addFindingCommentFN:(comment, finding) => dispatch(addFindingComment(comment, finding))

    };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(FindingOverlay);